import { Injectable } from '@angular/core';
import { HttpClient } from '@angular/common/http';
import { Observable } from 'rxjs';
import * as _ from 'lodash';
import { environment } from 'src/environments/environment';
import { Question } from '../../_models';


@Injectable({
  providedIn: 'root'
})
export class QuestionService {

  private apiUrl = `${environment.apiUrl}/Question`;

  constructor(private http: HttpClient) {
  }


  getByAssignmentId(assignmentId: number): Observable<Question[]> {
    return this.http.get<Question[]>(`${this.apiUrl}/GetByAssignmentId/${assignmentId}`);
  }

  getByAssignmentIdWithOptions(assignmentId: number): Observable<Question[]> {
    return this.http.get<Question[]>(`${this.apiUrl}/GetByAssignmentIdWithOptions/${assignmentId}`);
  }

  getByObjectiveId(objectiveId: number): Observable<Question[]> {
    return this.http.get<Question[]>(`${this.apiUrl}/GetByObjectiveId/${objectiveId}`);
  }

  getByIdWithOptions(questionId: number, assignmentId: number = null): Observable<Question> {
    return this.http.get<Question>(`${this.apiUrl}/GetByIdWithOptions/${questionId}${assignmentId ? '/' + assignmentId : ''}`);
  }


  addQuestion(question: Question): Observable<Question> {
    return this.http.post<Question>(`${this.apiUrl}/AddQuestion`, question);
  }

  updateQuestion(question: Question): Observable<Question> {
    return this.http.put<Question>(`${this.apiUrl}/UpdateQuestion`, question);
  }


  deleteQuestion(questionId: number): Observable<Question> {
    return this.http.delete<Question>(`${this.apiUrl}/DeleteQuestion/${questionId}`);
  }
}
